
import {
  NAME_MATCH_THRESHOLD,
} from "../constants/applyFlowConstants";

export const normalizeName = (value = "") =>
  String(value || "")
    .toUpperCase()
    .replace(/[^A-Z0-9 ]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const getPanName = (panProfile) => {
  const nameFromParts = [
    panProfile?.firstName,
    panProfile?.lastName,
  ]
    .filter(Boolean)
    .join(" ");

  return normalizeName(
    nameFromParts ||
      panProfile?.name ||
      ""
  );
};

export const getAadhaarName = (aadhaarProfile) => {
  const nameFromParts = [
    aadhaarProfile?.firstName,
    aadhaarProfile?.middleName,
    aadhaarProfile?.lastName,
  ]
    .filter(Boolean)
    .join(" ");

  return normalizeName(
    nameFromParts ||
      aadhaarProfile?.name ||
      ""
  );
};

export const getNameTokens = (name = "") => {
  return normalizeName(name)
    .split(" ")
    .filter(Boolean);
};

export const getTokenSimilarity = (a, b) => {
  if (!a || !b) return 0;

  if (a === b) return 100;

  const longer = Math.max(
    a.length,
    b.length
  );

  const shorter = Math.min(
    a.length,
    b.length
  );

  let same = 0;

  for (let i = 0; i < shorter; i += 1) {
    if (a[i] === b[i]) {
      same += 1;
    }
  }

  return (same / longer) * 100;
};

export const getNameMatchPercentage = (
  firstName,
  secondName
) => {
  const firstTokens =
    getNameTokens(firstName);

  const secondTokens =
    getNameTokens(secondName);

  if (
    !firstTokens.length ||
    !secondTokens.length
  ) {
    return 0;
  }

  const scores = firstTokens.map(
    (token) => {
      const bestMatch = Math.max(
        ...secondTokens.map(
          (candidate) =>
            getTokenSimilarity(
              token,
              candidate
            )
        )
      );

      return bestMatch;
    }
  );

  return (
    scores.reduce(
      (sum, score) => sum + score,
      0
    ) / scores.length
  );
};

export const normalizeDob = (value = "") => {
  const raw = String(value || "").trim();

  if (!raw) return "";

  const ymd = raw.match(
    /^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})/
  );

  if (ymd) {
    return `${ymd[1]}-${String(
      ymd[2]
    ).padStart(2, "0")}-${String(
      ymd[3]
    ).padStart(2, "0")}`;
  }

  const dmy = raw.match(
    /^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})/
  );

  if (dmy) {
    return `${dmy[3]}-${String(
      dmy[2]
    ).padStart(2, "0")}-${String(
      dmy[1]
    ).padStart(2, "0")}`;
  }

  return raw.replace(/\D/g, "");
};

export const validatePanAadhaarBank = ({
  panProfile,
  aadhaarProfile,
  bankHolderName,
}) => {
  const panName =
    getPanName(panProfile);

  const aadhaarName =
    getAadhaarName(aadhaarProfile);

  const bankName =
    normalizeName(bankHolderName);

  if (!panName) {
    return {
      ok: false,
      message:
        "PAN name is not available.",
    };
  }

  if (!aadhaarName) {
    return {
      ok: false,
      message:
        "Aadhaar name is not available.",
    };
  }

  // if (!bankName) {
  //   return {
  //     ok: false,
  //     message:
  //       "Bank account holder name is not available.",
  //   };
  // }

  const panAadhaarMatch =
    getNameMatchPercentage(
      panName,
      aadhaarName
    );

  const panBankMatch =
    getNameMatchPercentage(
      panName,
      bankName
    );

  const aadhaarBankMatch =
    getNameMatchPercentage(
      aadhaarName,
      bankName
    );

  console.log(
    "PAN Name:",
    panName
  );

  console.log(
    "Aadhaar Name:",
    aadhaarName
  );

  console.log(
    "Bank Name:",
    bankName
  );

  console.log(
    "PAN ↔ Aadhaar:",
    panAadhaarMatch
  );

  console.log(
    "PAN ↔ Bank:",
    panBankMatch
  );

  console.log(
    "Aadhaar ↔ Bank:",
    aadhaarBankMatch
  );

  // if (
  //   panAadhaarMatch <
  //     NAME_MATCH_THRESHOLD ||
  //   panBankMatch <
  //     NAME_MATCH_THRESHOLD ||
  //   aadhaarBankMatch <
  //     NAME_MATCH_THRESHOLD
  // ) {
  //   return {
  //     ok: false,
  //     message:
  //       "Name does not match with PAN, Aadhaar and bank account details.",
  //   };
  // }

  const panDob =
    normalizeDob(panProfile?.dob);

  const aadhaarDob =
    normalizeDob(
      aadhaarProfile?.dobRaw ||
        aadhaarProfile?.dob
    );

  console.log(
    "PAN DOB:",
    panDob
  );

  console.log(
    "Aadhaar DOB:",
    aadhaarDob
  );

  if (
    !panDob ||
    !aadhaarDob ||
    panDob !== aadhaarDob
  ) {
    return {
      ok: false,
      message:
        "DOB does not match",
    };
  }

  return {
    ok: true,
  };
};